import { render, staticRenderFns } from "./button-slide-up.vue?vue&type=template&id=0dc2e86c&scoped=true&"
var script = {}
import style0 from "./button-slide-up.vue?vue&type=style&index=0&id=0dc2e86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc2e86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc2e86c')) {
      api.createRecord('0dc2e86c', component.options)
    } else {
      api.reload('0dc2e86c', component.options)
    }
    module.hot.accept("./button-slide-up.vue?vue&type=template&id=0dc2e86c&scoped=true&", function () {
      api.rerender('0dc2e86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-slide-up.vue"
export default component.exports